import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { ToastContainer, toast } from "react-toastify";
import '@react-pdf-viewer/core/lib/styles/index.css';
import React, { useState, useEffect } from 'react';
import { Button, TextField } from '@mui/material'; 
import AOS from "aos";
import "aos/dist/aos.css"; 

export default function TcForm() {
  const [SRNo, setSRNo] = useState('')
  const [dob, setDob] = useState('')
  const [errors, setErrors] = useState(''); 
  const [PDF, setPDF] = useState(null); 

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTab: () => { return 1; },
  });

  const handleSRNoChange = (e) => {
    const value = e.target.value
    setSRNo(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      srNo: value ? '' : 'Please Enter SRNo'
    }));
    setPDF(null);
  }

  const handleDOBChange = (e) => {
    const value = e.target.value
    setDob(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      dob: value ? '' : 'Please Enter DOB'
    }));
    setPDF(null);
  }

  const handleReset = () => {
    setSRNo('')
    setDob('');
    setPDF(null);
  }

  const handleSearch = async (event) => {
    event.preventDefault();

    if (!SRNo || !dob) {
      setErrors((prevErrors) => ({
          ...prevErrors,
          SRNo: !SRNo ? 'SRNo is required' : prevErrors.SRNo,
          dob: !dob ? "Date Of Birth is required" : prevErrors.dob,
      }));

      return;
    } 

    try {
      const response = await fetch(`/api/getTc`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sRNo: SRNo, dob }),
      });

      if (response.ok) {
        const Data = await response.json();
        setPDF(Data[0].PDF);
      } else {
        setPDF(null);
        toast.error('Error fetching filtered data');
      }
    } catch (error) {
      console.error('Error fetching filtered data:', error);
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <>
      <div className='container d-felx my-5 align-items-center'>
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900" data-aos="fade-up">
            TC VERIFICATION
          </h2>
          <div className="w-24 h-1 bg-[#F4B400] mx-auto mt-4 rounded-full" data-aos="zoom-in" data-aos-delay="150"></div>
        </div>
        <div className='row my-3' data-aos="fade-up" data-aos-delay="200">
          <div className='col-6 col-md-3 mb-2' data-aos="fade-up" data-aos-delay="300">
            <TextField label='SRNo' variant='standard' fullWidth value={SRNo} onChange={handleSRNoChange} error={!!errors.SRNo} helperText={errors.SRNo} />
          </div>
          <div className='col-6 col-md-3 mb-2' data-aos="fade-up" data-aos-delay="400">
            <TextField label='Date Of Birth' variant='standard' type="Date" fullWidth value={dob} onChange={handleDOBChange} error={!!errors.dob} helperText={errors.dob} InputLabelProps={{ shrink: true }} />
          </div>
          <div className='col-6 col-md-3 mb-2' data-aos="fade-up" data-aos-delay="500">
            <Button variant='contained' color='primary' fullWidth onClick={handleSearch}>Search</Button>
          </div> 
          <div className='col-6 col-md-3 mb-2' data-aos="fade-up" data-aos-delay="500">
            <Button variant='contained' color='secondary' fullWidth onClick={handleReset}>Reset</Button>
          </div> 
        </div>
      </div> 
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            {PDF && <Viewer fileUrl={`/Documents/${PDF}`} plugins={[defaultLayoutPluginInstance]} defaultScale={1} />}
      </Worker>
      <ToastContainer />
    </>
  )
}
